import { useEffect, useState } from 'react';
import { onIdTokenChanged } from 'firebase/auth';
import { auth } from '../firebase';
import { apiRequest } from '../Services/apiClient';

export default function useAdminAccess() {
  const [state, setState] = useState({ loading: true, allowed: false, error: '' });
  useEffect(() => {
    let version = 0;
    const unsubscribe = onIdTokenChanged(auth, async user => {
      const request = ++version;
      setState({ loading: Boolean(user), allowed: false, error: '' });
      if (!user) return;
      try {
        const result = await apiRequest('admin/session');
        if (request === version) setState({ loading: false, allowed: result.role === 'Admin', error: '' });
      } catch (error) {
        if (request === version) setState({ loading: false, allowed: false, error: [401,403].includes(error.status) ? '' : error.message });
      }
    });
    return () => { version++; unsubscribe(); };
  }, []);
  return state;
}
